import styled from '@emotion/styled';
import { Button, IconButton, blue, grey, tokens } from '@galaxy-react/core';

export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => !['isSelected'].includes(prop as string),
})<{ isSelected?: boolean }>(({ isSelected }) => ({
  '&.fui-Button': {
    padding: `${tokens.spacingHorizontalS} ${tokens.spacingVerticalM}`,
    minWidth: 0,
    backgroundColor: isSelected ? blue[700] : grey[100],
    border: tokens.colorTransparentBackground,
    gap: tokens.spacingHorizontalXS,
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
    fontWeight: isSelected ? tokens.fontWeightSemibold : tokens.fontWeightRegular,
    color: isSelected ? 'white' : grey[800],
    // color: '#fff',
    transition: 'all .25s',
    '&:hover:not(:active)': {
      backgroundColor: isSelected ? blue[700] : grey[0],
    },
    '&:active': {
      color: isSelected ? grey[0] : grey[800],
      backgroundColor: isSelected ? blue[700] : grey[50],
      boxShadow: 'none',
      '& .fui-Button__icon': {
        svg: {
          color: isSelected ? grey[0] : blue[700],
        },
      },
      '& #delete-icon': {
        color: isSelected ? grey[0] : blue[700],
      },
    },
    '& .fui-Button__icon': {
      margin: 0,
      svg: {
        color: isSelected ? grey[0] : blue[700],
      },
    },
  },
}));

export const StyledDeleteIcon = styled(IconButton, {
  shouldForwardProp: (prop) => !['isSelected'].includes(prop as string),
})<{ isSelected?: boolean }>(({ isSelected }) => ({
  '&.fui-Button': {
    color: isSelected ? grey[0] : blue[700],
    padding: 0,
    height: 16,
    '&:hover': {
      backgroundColor: 'transparent',
      color: 'inherit',
    },
    '&:active': {
      boxShadow: 'none',
    },
  },
}));

export const StyledLabel = styled('div')({
  marginTop: -2,
  '::before': {
    display: 'block',
    content: 'attr(data-label)',
    height: '1px',
    color: tokens.colorTransparentBackground,
    overflow: 'hidden',
    visibility: 'hidden',
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
  },
});
